import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../models/user-profile.model';

@Injectable({
  providedIn: 'root'
})
export class RideService {

  constructor(
    private http: HttpClient
  ) { }

  getRouteLines(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + '/v2/routes/route-lines');
  }

  getBusStops(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/bus-stops', JSON.stringify(item));
  }

  getBusActivity(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/routes/bus-trip-activity', JSON.stringify(item));
  }

  getRideHistory(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + '/v2/transactions/rides');
  }
}
